import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import SelectAsanaBoard from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-asana-board';
import SelectBusinessProject from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-business-project';
import SelectClickupList from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-clickup-list';
import SelectMondayBoard from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-monday-board';
import SelectSoftwareProject from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-software-project';
import SelectTrelloBoard from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-trello-board';
import {
	ASANA,
	MONDAY,
	type SupportedThirdParty,
	TRELLO,
	JIRA_SOFTWARE,
	CLICK_UP,
	JIRA_BUSINESS,
} from '../../../common/constants/import-type';

type Props = {
	thirdParty: SupportedThirdParty;
};

export const ThirdPartyIllustration = ({ thirdParty }: Props) => (
	<Box xcss={containerStyles}>{ThirdPartyIllustrations({ thirdParty })}</Box>
);

export const ThirdPartyIllustrations = ({ thirdParty }: Props) => {
	switch (thirdParty) {
		case MONDAY:
			return (
				<SelectMondayBoard
					alt="select monday board"
					data-testid="project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.monday"
				/>
			);
		case ASANA:
			return (
				<SelectAsanaBoard
					alt="select asana board"
					data-testid="project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.asana"
				/>
			);
		case TRELLO:
			return (
				<SelectTrelloBoard
					alt="select trello board"
					data-testid="project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.trello"
				/>
			);
		case JIRA_SOFTWARE:
			return (
				<SelectSoftwareProject
					alt="select jira software board"
					data-testid="project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.jira-software"
				/>
			);
		case CLICK_UP:
			return (
				<SelectClickupList
					alt="select clickup board"
					data-testid="project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.clickup"
				/>
			);
		case JIRA_BUSINESS:
			return (
				<SelectBusinessProject
					alt="select jira business board"
					data-testid="project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.jira-business"
				/>
			);
		default:
			return null;
	}
};

const containerStyles = xcss({
	width: '400px',
	marginTop: 'space.1000',
});
